module.exports = __webpack_public_path__ + "img/bbq.fad3448e.png";